import { render, staticRenderFns } from "./RbuSectionFluctuation.vue?vue&type=template&id=41bb64a6"
import script from "./RbuSectionFluctuation.vue?vue&type=script&lang=js"
export * from "./RbuSectionFluctuation.vue?vue&type=script&lang=js"
import style0 from "./RbuSectionFluctuation.vue?vue&type=style&index=0&id=41bb64a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports